import { PixiBase } from './PixiBase';
import { pixiResourceHelper } from '../../helpers/pixiResourceHelper';

export class PixiGameDrawer {
  loadedResourceKeys = [];

  constructor({ PIXI, Spine, config }) {
    PixiBase.PIXI = PIXI;
    PixiBase.Spine = Spine;

    this.pixiApplication = PixiBase.createApplication({
      ...config,
      antialias: true,
      autoDensity: true,
      resolution: 1.5,
    });

    this.stage = this.pixiApplication.stage;
  }

  scalePixiAppStage(scaleValue) {
    this.pixiApplication.stage.scale = scaleValue;
  }

  setupContainers(containers) {
    this.stage.addChild(...containers);
  }

  loadResource({ resource, loader }) {
    return new Promise((resolve) => {
      resource.forEach((item) => {
        // eslint-disable-next-line no-restricted-syntax, guard-for-in
        for (const key in item) {
          loader.add({ alias: key, src: item[key].path, data: item[key].config });
          // eslint-disable-next-line no-loop-func
          this.loadedResourceKeys.push(key);
        }
      });

      this.allResourceDynamicLoader(loader, resolve, resource);
    });
  }

  currentResourceDynamicLoader(loader, currentKey, startedIndexResource, resolve) {
    return loader
      .load(currentKey)
      .then((res) => {
        pixiResourceHelper.declareResources({ [currentKey]: res });

        this.loadedResourceKeys = this.loadedResourceKeys.slice(startedIndexResource);
        if (this.loadedResourceKeys?.length) {
          this.allResourceDynamicLoader(loader, resolve);
        }
      })
      .catch(() => {
        this.currentResourceDynamicLoader(loader, currentKey);
      });
  }

  allResourceDynamicLoader(loader, resolve) {
    try {
      loader
        .load(this.loadedResourceKeys)
        .then((res) => {
          this.loadedResourceKeys.forEach((key) => {
            pixiResourceHelper.declareResources({ [key]: res[key] });
          });
          resolve();
        })
        .catch((e) => {
          console.log(e, 'catch');
        });
    } catch (e) {
      const notLoadedResourceIndex = [...this.loadedResourceKeys].findIndex((item) =>
        e.message.includes(item)
      );

      this.loadedResourceKeys[notLoadedResourceIndex] &&
        this.currentResourceDynamicLoader(
          loader,
          this.loadedResourceKeys[notLoadedResourceIndex],
          notLoadedResourceIndex,
          resolve
        );
    }
  }
}
